module.exports = __webpack_public_path__ + "primeicons.473e2a74.ttf";